export default "__VITE_ASSET__BLbzZ28i__"